import React, { useState, useRef, useEffect } from "react";
import {
    UserOutlined,
    PhoneOutlined,
    MailOutlined,
    IdcardOutlined,
    CalendarOutlined,
    TeamOutlined,
    FileTextOutlined,
    ArrowLeftOutlined,
    CheckCircleOutlined,
    HomeOutlined,
    AppstoreOutlined,
    StarFilled,
    CloudUploadOutlined,
    DeleteOutlined,
    EyeOutlined,
    DownOutlined,
    SaveOutlined,
    LogoutOutlined,
    ToolOutlined,
    LoginOutlined,
    CloseCircleOutlined,
    PlusOutlined,
    CloseOutlined,
    InfoCircleOutlined,
    InfoOutlined,
    DeleteRowOutlined,
} from "@ant-design/icons";
import { Alert, Button, Card, DatePicker, Dropdown, Image, Modal, Popconfirm, Radio, Result, Space, Table, TimePicker, Tooltip, Switch } from "antd";
import CheckOutModal from "./CheckOutModal";
import { currentDate, currentTime, formatDate } from "../../../components/Customs/dateFormatter";
import dayjs from "dayjs";
import { navigate } from "../../../components/Customs/navigation";
import { useLocation } from "react-router-dom";
import { BooknLogService } from "../../../Services/BooknLogService";
import { notify } from "../../../components/Customs/NotifyProvider";
import { ENDPOINTS } from "../../../Services/ENDPOINT";
import { styles } from "./Styles";
import { css, DEFAULT_CFG, STATUS_CONFIG, T } from "../../Styles/css";
import { DetailItem, SectionCard, StatusBadge } from "../../../components/Rooms/history/History";
import { RoomServices } from "../../../Services/RoomServices";
import maintance from "../../../../assets/room-maintance.jpg";
import CancleCheckModal from "./CancleCheckModal";
import ServiceRequestModal from "./ServiceRequestModal";
import { CheckInOutCard } from "./CheckInOutCard";
import { GeneralService } from "../../../Services/GeneralService";
import { UpcomingBookingsList } from "./UpcomingBookingsList";
import axios from "axios";
import generatePDF from "../../../components/Customs/generatePDF";
import generateA4PDF from "../../../components/Customs/generateA4PDF";

import { Empty } from "antd";
import { canViewModule, canCreateModule, canUpdateModule, canDeleteModule } from "../../../../utils/permissionUtils";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

const MODULE_KEY = "book_room_action";

const { RangePicker } = DatePicker;

export default function BookRoomPage() {
    const location = useLocation();
    const navRoom = location.state?.room;
    const [room, setRoom] = useState({});
    const check_in_date = location.state?.check_in;
    const check_time = location.state?.check_time;


    const isOnlineBookingView = location.state?.source === 'online_booking'; // ← add this
    const onlineBooking = location.state?.booking ?? null;                   // ← and this

    const cfg = STATUS_CONFIG[room.status?.toLowerCase()] || DEFAULT_CFG;
    let amenities = [];
    try {
        amenities = JSON.parse(room.amenities || "[]");
    } catch { }

    const todayDate = dayjs();
    const tomorrowDate = dayjs().add(1, "day");

    const initialCheckIn = check_in_date
        ? dayjs(check_in_date).format("YYYY-MM-DD")
        : todayDate.format("YYYY-MM-DD");

    const initialCheckOut = check_in_date
        ? dayjs(check_in_date).add(1, "day").format("YYYY-MM-DD")
        : tomorrowDate.format("YYYY-MM-DD");


const getRoomByPrice = async (from, to, room_id) => {
    try {
        const req = await RoomServices.getRoomByPrice(from, to, room_id);
        console.log("rooms spl prices via room", req.data);
        if (req.data?.[0]) {
            setRoom(req.data[0]);
        } else {
            setRoom(navRoom);
        }
    } catch (error) {
        console.log(error);
        setRoom(navRoom);
    }
}

    useEffect(() => {
        getRoomByPrice(check_in_date, check_in_date, navRoom.id)
    }, [navRoom])


    // console.log("isOnlineBookingView", isOnlineBookingView);
    console.log("check_in_date", check_in_date);

    // console.log("room******", room);
    console.log("onlineBooking+++++++", onlineBooking);

    //     const req = {
    //          a: dayjs(check_time.checkin).format("hh:mm:ss A"),
    //  b : dayjs(check_time.checkout).format("hh:mm:ss A"),
    //     }
    // console.log("check_timess++++++++++++++++++++", check_time);

    // const todayDate = dayjs();
    // const tomorrowDate = dayjs().add(1, "day");

    const [form, setForm] = useState({
        guest_name: "",
        phone: "",
        email: "",
        id_type: "Aadhaar",
        id_number: "",
        address: "",
        guests: 1,
        check_in: initialCheckIn,
        check_out: initialCheckOut,
        special_requests: "",
        customer_gst: "",
        payment_mode: "Cash",
        check_in_time: check_time.a,
        check_out_time: check_time.b,
        child: 0,
        infant: 0,
        child_age: [],
    });

    const [docs, setDocs] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const fileRef = useRef();
    const dropdownRef = useRef();

    const [successData, setSuccessData] = useState(null);

    const [docFiles, setDocFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [bookId, setBookId] = useState("");
    const [existingUser, setExistingUser] = useState(null);

    // ── Check-Out Modal state ──────────────────────────
    const [checkOutModalOpen, setCheckOutModalOpen] = useState(false);
    const [cancelCheckModalOpen, setCancelCheckModalOpen] = useState(false);
    const [serviceReqModalOpen, setServiceReqModalOpen] = useState(false);
    const [checkOutLoading, setCheckOutLoading] = useState(false);
    const [resevDate, setResvDate] = useState([]);
    const [isNewReservation, setIsNewReservation] = useState(false);
    const [allBookings, setAllBookings] = useState([]);
    const [selectedUpcoming, setSelectedUpcoming] = useState(null);
    const [acRequired, setAcRequired] = useState(true);
    const [exCustomer, setExCustomer] = useState([]);
    const [showActions, setShowActions] = useState(true);

    const [defaultCheckInTime, setDefaultCheckInTime] = useState(null);
    const [defaultCheckOutTime, setDefaultCheckOutTime] = useState(null);
    const [loyalDiscount, setLoyalDiscount] = useState('');

    const [headerImg, setHeaderImg] = useState('');
    const [a4PdfHeaderImg, setA4PdfHeaderImg] = useState('');
    const [footerImg, setFooterImg] = useState('');
    const [gst, setGst] = useState('');
    const [gstType, setGstType] = useState("exclusive");
    const [hourlyBook, setHourlyBook] = useState(false);
    const [fullBooking, setFullBooking] = useState(false);

    const [finalRemainingPayable, setFinalRemaining] = useState(0);

    const [activeAllowedRange, setActiveAllowedRange] = useState({
        start: initialCheckIn,
        end: initialCheckOut,
    });

    const emptyForm = {
        guest_name: "",
        phone: "",
        email: "",
        id_type: "Aadhaar",
        id_number: "",
        address: "",
        guests: 1,
        check_in: todayDate.format("YYYY-MM-DD"),
        check_out: tomorrowDate.format("YYYY-MM-DD"),
        special_requests: "",
        customer_gst: '',
        payment_mode: "Cash",
        check_in_time: defaultCheckInTime,
        check_out_time: defaultCheckOutTime,
    };

    const isFutureBooking = dayjs(form.check_in).isAfter(dayjs(), "day");

    console.log("gstType", gstType);

    const setFormWithAllowedRange = (data) => {
        setForm(data);

        if (data.check_in && data.check_out) {
            setActiveAllowedRange({
                start: data.check_in,
                end: data.check_out,
            });
        }
    };


    useEffect(() => {
        if (!isOnlineBookingView || !onlineBooking) return;

        console.log("xx", room);


        console.log("onlineBookingXXxxxxxxxxxxxxx", onlineBooking.bl_id);


        // setForm({
        setFormWithAllowedRange({
            guest_name: onlineBooking.guest_name ?? '',
            phone: onlineBooking.phone ?? '',
            customer_gst: onlineBooking.customer_gst ?? '',
            email: onlineBooking.email ?? '',
            id_type: onlineBooking.id_type ?? 'Aadhaar',
            id_number: onlineBooking.id_number ?? '',
            address: onlineBooking.address ?? '',
            guests: Number(onlineBooking.guests) || 1,
            check_in: onlineBooking.check_in ?? todayDate.format('YYYY-MM-DD'),
            check_out: onlineBooking.check_out ?? tomorrowDate.format('YYYY-MM-DD'),
            special_requests: onlineBooking.special_requests ?? '',
            payment_mode: onlineBooking.payment_mode ?? 'Cash',
            br_id: onlineBooking.id,
            bl_id: onlineBooking.bl_id,
            ac_required: onlineBooking.ac_required,
            // check_in_time: check_time.a,
            // check_out_time: check_time.b,

            child: Number(onlineBooking.child || 0),

            child_age: Array.isArray(onlineBooking.child_age)
                ? onlineBooking.child_age
                : typeof onlineBooking.child_age === "string"
                    ? JSON.parse(onlineBooking.child_age || "[]")
                    : [],

            ...onlineBooking

        });

        setAcRequired(onlineBooking.ac_required === "true" || onlineBooking.ac_required === true);

        const onlinePricing = parsePricing(onlineBooking);
        setGstType(onlinePricing?.gst_type || "exclusive");
        setHourlyBook(isHourlyFromPricing(onlinePricing));
        setPaymentRows(normalisePaymentRows(onlinePricing, onlineBooking?.paid_amount, onlineBooking?.payment_mode));
        setGstType(onlinePricing?.gst_type || "exclusive");

        // Load any documents that were uploaded with the online booking
        try {
            const paths = JSON.parse(onlineBooking.document_upload || '[]');
            const BASE = ENDPOINTS.cleanBase1;
            setDocs(paths.map((p) => {
                const name = p.split('/').pop();
                const ext = name.split('.').pop().toLowerCase();
                const mime = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
                    ? `image/${ext === 'jpg' ? 'jpeg' : ext}`
                    : 'application/pdf';
                return { name, size: 'existing', type: mime, url: BASE + p, existing: true };
            }));
        } catch { setDocs([]); }
    }, [isOnlineBookingView]);



    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                // setDropdownOpen(false); — removed unused state
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    useEffect(() => {
        if (existingUser?.length > 0) {
            const u = existingUser[0];
            console.log(")))))", existingUser);

            // setForm({
            setFormWithAllowedRange({
                guest_name: u.guest_name || "",
                phone: u.phone || "",
                email: u.email || "",
                id_type: u.id_type || "Aadhaar",
                id_number: u.id_number || "",
                address: u.address || "",
                guests: Number(u.guests) || 1,
                check_in: u.check_in || todayDate.format("YYYY-MM-DD"),
                check_out: u.check_out || tomorrowDate.format("YYYY-MM-DD"),
                special_requests: u.special_requests || "",
                payment_mode: u.payment_mode || "Cash",
                ac_required: u.ac_required,
                child: u.child,
                child_age: u.child_age,
                ...u
            });

            setAcRequired(u.ac_required === "true" || u.ac_required === true);

            const existingPricing = parsePricing(u);
            setGstType(existingPricing?.gst_type || "exclusive");
            setHourlyBook(isHourlyFromPricing(existingPricing));
            setPaymentRows(normalisePaymentRows(existingPricing, u?.paid_amount, u?.payment_mode));
            setGstType(existingPricing?.gst_type || "exclusive");

            console.log("xxxxxxx", u);


            try {
                const uploadedPaths = JSON.parse(u.document_upload || "[]");
                const BASE_URL = ENDPOINTS.cleanBase1;
                const mapped = uploadedPaths.map((path) => {
                    const fileName = path.split("/").pop();
                    const ext = fileName.split(".").pop().toLowerCase();
                    const mime = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext)
                        ? `image/${ext === "jpg" ? "jpeg" : ext}`
                        : "application/pdf";
                    return {
                        name: fileName,
                        size: "existing",
                        type: mime,
                        url: BASE_URL + path,
                        existing: true,
                    };
                });
                setDocs(mapped);
            } catch (err) {
                console.error("Failed to parse document_upload:", err);
            }
        }
    }, [existingUser]);

    useEffect(() => {
        getExistingCust();
        getCheckTime();
    }, [])

    const getCheckTime = async () => {
        try {
            const req = await RoomServices.getAllByTable("utills");

            const checkInTime = req.data?.[0]?.checkin_time;
            const checkOutTime = req.data?.[0]?.checkout_time;

            setDefaultCheckInTime(
                checkInTime
                    ? dayjs(checkInTime, "hh:mm A")
                    : null
            );

            setDefaultCheckOutTime(
                checkOutTime
                    ? dayjs(checkOutTime, "hh:mm A")
                    : null
            );

            setHeaderImg(req.data?.[0]?.header_img);
            setFooterImg(req.data?.[0]?.footer_img);
            setA4PdfHeaderImg(req.data?.[0]?.a4_pdf_header_img);
            setGst(req.data?.[0]?.gst);

        } catch (error) {
            console.error(error);

            setDefaultCheckInTime(null);
            setDefaultCheckOutTime(null);
        }
    };

    const getReservedDate = async () => {
        try {
            const req = await GeneralService.getReserOccData(navRoom.id)
            console.log("getReservedDate", req.data);
            setResvDate(req.data);

            console.log("room-id", navRoom.id);


        } catch (error) {
            console.error(error);

        }
    }

    const getExistingCust = async () => {
        try {
            const req = await GeneralService.get("book_room");

            const uniqueCustomers = Object.values(
                req.data
                    .filter(
                        (item) =>
                            item.phone &&
                            item.phone.toString().trim() !== ""
                    )
                    .reduce((acc, item) => {
                        // overwrite previous record with same phone
                        acc[item.phone] = item;
                        return acc;
                    }, {})
            );

            setExCustomer(uniqueCustomers);

            // console.log("getExistingCust", uniqueCustomers);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchAllBookings = async () => {
        try {
            const res = await axios.get(`${ENDPOINTS.BOOKROOM}?id=${navRoom.id}&status=all&check_in=${check_in_date}`);

            console.log(`${ENDPOINTS.BOOKROOM}?id=${navRoom.id}&status=all`);

            setAllBookings(res.data?.data || []);

            const bookings = res.data?.data || [];

            // const firstBooking = bookings[0];
            const firstBooking = null;

            if (firstBooking) {
                // setForm({
                setFormWithAllowedRange({
                    guest_name: firstBooking.guest_name || "",
                    phone: firstBooking.phone || "",
                    email: firstBooking.email || "",
                    id_type: firstBooking.id_type || "Aadhaar",
                    id_number: firstBooking.id_number || "",
                    address: firstBooking.address || "",
                    guests: firstBooking.guests || 1,
                    check_in: firstBooking.check_in || "",
                    check_out: firstBooking.check_out || "",
                    check_in_time: firstBooking.check_in_time || "",
                    check_out_time: firstBooking.check_out_time || "",
                    special_requests: firstBooking.special_requests || "",
                    payment_mode: firstBooking.payment_mode || "Cash",
                    paid_amount: firstBooking.paid_amount || "",
                    customer_gst: firstBooking.customer_gst || "",
                    ac_required: firstBooking.ac_required === "true" || firstBooking.ac_required === true,
                    book_room_id: firstBooking.book_room_id || "",
                    room_id: firstBooking.room_id || "",
                    child: Number(firstBooking.child || 0),
                    child_age: Array.isArray(firstBooking.child_age)
                        ? firstBooking.child_age
                        : typeof firstBooking.child_age === "string"
                            ? JSON.parse(firstBooking.child_age || "[]")
                            : [],

                });
            }

            console.log("fetchAllBookings", res.data);

        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (isOnlineBookingView) return;
        fetchAllBookings()
        getReservedDate()
    }, [navRoom.id])


    const reservedRanges = resevDate.map(r => ({
        start: dayjs(r.check_in),
        end: dayjs(r.check_out)
    }));



    const handleUpcomingSelect = (booking) => {
        if (selectedUpcoming?.bl_id === booking.bl_id) {
            // Deselect — restore original existing user
            setSelectedUpcoming(null);

            if (existingUser?.length > 0) {
                const u = existingUser[0];
                // setForm({
                setFormWithAllowedRange({
                    ...emptyForm, ...u, guests: Number(u.guests) || 1
                });
            } else {
                setForm(emptyForm);
            }
            setPaymentRows([]);

            setIsNewReservation(false);
            return;
        }

        setSelectedUpcoming(booking);
        setIsNewReservation(true);
        setShowActions(true);

        console.log("booking*******", booking);

        const pricing =
            typeof booking.pricing_summary === "string"
                ? JSON.parse(booking.pricing_summary)
                : booking.pricing_summary || {};

        setGstType(pricing?.gst_type || "exclusive");

        setHourlyBook(isHourlyFromPricing(pricing));

        setHourlyBook(isHourlyFromPricing(pricing));

        console.log("Parsed pricing summary", pricing);

        // Set payment states properly
        setPaymentRows(normalisePaymentRows(pricing, booking?.paid_amount, booking?.payment_mode));
        setGstType(pricing.gst_type || "exclusive");
        setAcRequired(booking.ac_required === "true" || booking.ac_required === true);
        setFullBooking(booking.full_book === "true" || booking.full_book === true);

        // Optional logs
        console.log("Payment Status", pricing.payment_status);
        console.log("Remaining Payable", pricing.remaining_payable);
        console.log("Received Advance", pricing.received_advance);


        // Populate form with this upcoming booking's data
        // setForm({
        setFormWithAllowedRange({
            guest_name: booking.guest_name || "",
            phone: booking.phone || "",
            email: booking.email || "",
            id_type: booking.id_type || "Aadhaar",
            id_number: booking.id_number || "",
            address: booking.address || "",
            guests: Number(booking.guests) || 1,
            check_in: dayjs(booking.check_in).format("YYYY-MM-DD"),
            check_out: dayjs(booking.check_out).format("YYYY-MM-DD"),
            special_requests: booking.special_requests || "",
            payment_mode: booking.payment_mode || "Cash",
            ac_required: booking.ac_required,

            customer_gst: booking.customer_gst,
            check_in_time: booking.check_in_time,
            check_out_time: booking.check_out_time,

            // child: booking.child || "",
            // child_age: booking.child_age || "",
            child: Number(booking.child || 0),
            child_age: Array.isArray(booking.child_age)
                ? booking.child_age
                : typeof booking.child_age === "string"
                    ? JSON.parse(booking.child_age || "[]")
                    : [],

        });

        // Load docs if any
        try {
            const paths = JSON.parse(booking.document_upload || "[]");
            const BASE = ENDPOINTS.cleanBase1;
            setDocs(paths.map((p) => {
                const name = p.split("/").pop();
                const ext = name.split(".").pop().toLowerCase();
                const mime = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext)
                    ? `image/${ext === "jpg" ? "jpeg" : ext}`
                    : "application/pdf";
                return { name, size: "existing", type: mime, url: BASE + p, existing: true };
            }));
        } catch { setDocs([]); }

        setErrors({});
        setDocFiles([]);
    };

    const handlePhoneChange = async (phoneValue) => {
        set("phone", phoneValue);

        const selectedCustomer = exCustomer.find(
            (c) => String(c.phone || "").trim() === String(phoneValue || "").trim()
        );

        // if number not found, no problem
        if (!selectedCustomer) return;

        console.log("selectedCustomer", selectedCustomer);

        const req = await GeneralService.loyality_discount(selectedCustomer.phone);
        console.log("req", req);

        if (req.eligible) {
            notify.success("Congratulations!", req.message);
            setLoyalDiscount(Number(req.discount));
        } else {
            notify.info(req.message);
            setLoyalDiscount(null);
        }

        setForm((prev) => ({
            ...prev,
            phone: selectedCustomer.phone || phoneValue,
            guest_name: selectedCustomer.guest_name || "",
            customer_gst: selectedCustomer.customer_gst || "",
            email: selectedCustomer.email || "",
            id_type: selectedCustomer.id_type || "Aadhaar",
            id_number: selectedCustomer.id_number || "",
            address: selectedCustomer.address || "",
        }));
    };

    const items = [
        {
            key: "occupied",
            label: (
                <span style={{ color: "green" }}>
                    <CheckCircleOutlined style={{ marginRight: 7, fontSize: 20 }} />{" "}
                    Confirm Booking
                </span>
            ),
            disabled: isFutureBooking,
        },
        {
            key: "reserved",
            label: (
                <span style={{ color: "red" }}>
                    <CalendarOutlined style={{ marginRight: 7, fontSize: 20 }} /> Reserve Room
                </span>
            ),
        },
    ];

    const parsePricing = (data) => {
        if (!data?.pricing_summary) return null;

        try {
            return typeof data.pricing_summary === "string"
                ? JSON.parse(data.pricing_summary)
                : data.pricing_summary;
        } catch (error) {
            console.error("Failed to parse pricing_summary:", error);
            return null;
        }
    };

    const isHourlyFromPricing = (pricing) => {
        return (
            pricing?.booking_type === "hourly" ||
            pricing?.bookingType === "hourly" ||
            Number(pricing?.duration_hours || 0) > 0
        );
    };


    const currentPricing =
        parsePricing(selectedUpcoming) ||
        parsePricing(onlineBooking) ||
        parsePricing(existingUser?.[0]) ||
        null;

    // Always use the current checkbox/form state.
    // Do not let old pricing_summary override newly edited booking type.
    const isHourlyBooking = hourlyBook;



    const handleMenuClick = ({ key }) => {
        handleSubmit(key);
    };

    const onBack = () => {
        navigate(-1);
    };

    const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

    const nights = (() => {
        if (!form.check_in || !form.check_out) return 0;
        const d = (new Date(form.check_out) - new Date(form.check_in)) / 86400000;
        return d > 0 ? d : 1;
    })();

    const max_persona = Number(room.max_occupancy || 0) + Number(room.additional_occupancy || 0);

    console.log("max_persona", max_persona);

    const extraGuests = Math.max(0, (form.guests || 1) - (room.max_occupancy || 0));
    const extraCostPerNight = extraGuests * (room.add_cost_per_occupancy || 0);


    const getTimeDiffHours = () => {
        if (
            !form.check_in ||
            !form.check_out ||
            !form.check_in_time ||
            !form.check_out_time
        ) {
            return 1;
        }

        const start = dayjs(
            `${form.check_in} ${form.check_in_time}`,
            "YYYY-MM-DD hh:mm A"
        );

        const end = dayjs(
            `${form.check_out} ${form.check_out_time}`,
            "YYYY-MM-DD hh:mm A"
        );

        const minutes = end.diff(start, "minute");

        return Math.max(Math.ceil(minutes / 60), 1);
    };

    // Always recalculate hours from current selected check-in/check-out time.
    const totalHours = getTimeDiffHours();

    const earlyCheckinAmount = (() => {
        if (fullBooking) return 0;

        if (!form.check_in_time || !defaultCheckInTime) return 0;

        const guestIn = dayjs(form.check_in_time, "hh:mm A");

        const defStr =
            typeof defaultCheckInTime === "object"
                ? defaultCheckInTime.format("hh:mm A")
                : String(defaultCheckInTime);

        const def = dayjs(defStr, "hh:mm A");

        if (!guestIn.isValid() || !def.isValid()) return 0;

        const guestMins = guestIn.hour() * 60 + guestIn.minute();
        const defMins = def.hour() * 60 + def.minute();

        if (guestMins < defMins) {
            const diffMins = defMins - guestMins;

            return Math.round(
                (diffMins / 60) * Number(room.total_price_per_hour || room.price_per_hour || 0)
            );
        }

        return 0;
    })();

    const toNum = (v) => {
        const n = Number(String(v ?? 0).replace(/,/g, ""));
        return Number.isFinite(n) ? n : 0;
    };

    const adultCount = Number(form.guests || 0);
    const childCount = Number(form.child || 0);
    const maxOccupancy = Number(room.max_occupancy || 0);
    const remainingNormalOccupancy = Math.max(0, maxOccupancy - adultCount);

    const childCostPerPerson = toNum(room.child_cost_per_person || 0);
    const extraChild = Math.max(0, childCount - remainingNormalOccupancy);

    const extraChildCostPerNight =
        extraChild * childCostPerPerson;


const baseTotal = isHourlyBooking
    ? totalHours * Number(room.total_price_per_hour || room.price_per_hour || 0)
    : room.total_price_per_day
        ? Number(room.total_price_per_day)
    : Number(room.price_per_day || 0) * nights;

    const extraTotal = isHourlyBooking
        ? totalHours * extraCostPerNight
        : nights * extraCostPerNight;

    const extraChildTotal = isHourlyBooking
        ? totalHours * extraChildCostPerNight
        : nights * extraChildCostPerNight;

    const acChargeTotal = acRequired
        ? isHourlyBooking
            ? Number(room.ac_charge || 0) * nights
            : Number(room.ac_charge || 0) * nights
        : 0;

    const full_book = fullBooking
        ? isHourlyBooking
            ? Number(room.additional_24_hour || 0)
            : Number(room.additional_24_hour || 0) * nights
        : 0;

    // const childCostPerPerson = Number(room.child_cost_per_person || 0);

    const total = baseTotal + extraTotal + acChargeTotal + full_book + earlyCheckinAmount + extraChildTotal;

    console.log({
        baseTotal,
        extraTotal,
        acChargeTotal,
        full_book,
        earlyCheckinAmount,
        extraChildTotal,
    });


    const [paymentRows, setPaymentRows] = useState([]);

    const normalisePaymentRows = (pricing, fallbackPaid = 0, fallbackMode = "Cash") => {
        const rows = Array.isArray(pricing?.payment_rows)
            ? pricing.payment_rows
            : typeof pricing?.payment_rows === "string"
                ? (() => {
                    try { return JSON.parse(pricing.payment_rows || "[]"); }
                    catch { return []; }
                })()
                : [];

        if (rows.length > 0) {
            return rows.map((row, index) => ({
                key: row.key || `${Date.now()}-${index}`,
                type: row.type || "advance",
                amount: Number(row.amount || 0),
                mode: row.mode || fallbackMode || "Cash",
                date: row.date || dayjs().format("YYYY-MM-DD"),
            }));
        }

        const paid = Number(pricing?.paid_amount ?? fallbackPaid ?? 0);
        const discount = Number(pricing?.discount_amount || 0);
        const mode = pricing?.payment_mode || fallbackMode || "Cash";
        const generated = [];

        if (paid > 0) {
            generated.push({
                key: `${Date.now()}-advance`,
                type: "advance",
                amount: paid,
                mode,
                date: dayjs().format("YYYY-MM-DD"),
            });
        }

        if (discount > 0) {
            generated.push({
                key: `${Date.now()}-discount`,
                type: "discount",
                amount: discount,
                mode,
                date: dayjs().format("YYYY-MM-DD"),
            });
        }

        return generated;
    };

    // const getUsedAmountExceptCurrent = (rows, currentKey) => {
    //     return rows
    //         .filter((row) => row.key !== currentKey)
    //         .reduce((sum, row) => sum + Number(row.amount || 0), 0);
    // };
    const getUsedAmountExceptCurrent = (rows, currentKey) => {
        return rows
            .filter((row) => row.key !== currentKey && row.type !== "discount")
            .reduce((sum, row) => sum + Number(row.amount || 0), 0);
    };

    const addPaymentRow = (type = "advance") => {
        if (finalRemaining <= 0) {
            notify.info("Remaining payable is already 0. Cannot add advance or discount.");
            return;
        }

        setPaymentRows((prev) => [
            ...prev,
            {
                key: `${Date.now()}-${Math.random()}`,
                type,
                amount: 0,
                mode: form.payment_mode || "Cash",
                date: dayjs().format("YYYY-MM-DD"),
            },
        ]);
    };


    const updatePaymentRow = (key, field, value) => {
        setPaymentRows((prev) => {
            const currentRow = prev.find((row) => row.key === key);
            if (!currentRow) return prev;

            // When payment type changes to Full Pay
            if (field === "type" && value === "full_pay") {
                const usedAmountExceptCurrent = getUsedAmountExceptCurrent(prev, key);
                const remainingAmount = Math.max(
                    finalPayableAfterDiscount - usedAmountExceptCurrent,
                    0
                );

                return prev.map((row) =>
                    row.key === key
                        ? {
                            ...row,
                            type: value,
                            amount: remainingAmount,
                        }
                        : row
                );
            }

            if (field === "amount") {
                const enteredAmount = Math.max(0, Number(value || 0));

                const usedAmountExceptCurrent = getUsedAmountExceptCurrent(prev, key);
                const allowedAmount = Math.max(
                    finalPayableAfterDiscount - usedAmountExceptCurrent,
                    0
                );

                return prev.map((row) =>
                    row.key === key
                        ? {
                            ...row,
                            amount: Math.min(enteredAmount, allowedAmount),
                        }
                        : row
                );
            }

            return prev.map((row) =>
                row.key === key ? { ...row, [field]: value } : row
            );
        });
    };

    const removePaymentRow = (key) => {
        setPaymentRows((prev) => prev.filter((row) => row.key !== key));
    };




    // console.log("currentPricing<<<<<<<<<<<<",currentPricing);

    // const rawTotal = currentPricing
    //     ? Number(currentPricing.total_before_loyalty_discount ?? currentPricing.total_amount ?? 0)
    //     - Number(currentPricing.early_checkin_amount || 0)
    //     + earlyCheckinAmount
    //     : Number(total || 0) + earlyCheckinAmount;

    // Live price calculation.
    // Important: do not use old pricing_summary.total_amount here,
    // because selected upcoming/online bookings may already have stale price data.
    const rawTotal = Number(total || 0);

    const loyaltyDiscountPercent = Number(
        currentPricing?.loyalty_discount_percent ?? loyalDiscount ?? 0
    );

    const loyaltyDiscountAmount =
        loyaltyDiscountPercent > 0
            ? Number(((rawTotal * loyaltyDiscountPercent) / 100).toFixed(2))
            : 0;

    const payableTotal = Math.max(rawTotal - loyaltyDiscountAmount, 0);

    const gstPercent = Number(gst || 0);

    const gstAmount =
        gstPercent > 0
            ? Math.round((payableTotal * gstPercent) / 100)
            : 0;

const finalPayableTotal =
    gstType === "inclusive"
        ? Number((payableTotal + gstAmount).toFixed(2))
        : payableTotal;

    // const totalAdvance = paymentRows
    //     .filter((row) => row.type === "advance")
    //     .reduce((sum, row) => sum + Number(row.amount || 0), 0);

    // const totalDiscount = paymentRows
    //     .filter((row) => row.type === "discount")
    //     .reduce((sum, row) => sum + Number(row.amount || 0), 0);

    const totalAdvance = paymentRows
        .filter((row) => row.type === "advance" || row.type === "full_pay")
        .reduce((sum, row) => sum + Number(row.amount || 0), 0);

    const totalDiscount = paymentRows
        .filter((row) => row.type === "discount")
        .reduce((sum, row) => sum + Number(row.amount || 0), 0);


    const finalPayableAfterDiscount = Math.max(finalPayableTotal - totalDiscount, 0);
    const finalRemaining = Math.max(finalPayableAfterDiscount - totalAdvance, 0);
    const isFullyPaid = finalRemaining === 0;

    const paidValue = totalAdvance;
    const discountAmount = totalDiscount;
    const receivedAdvance = totalAdvance;
    const remainingPayable = finalRemaining;
    const amountType = totalDiscount > 0 ? "discount" : totalAdvance > 0 ? "advance" : null;

    const paymentStatus =
        totalDiscount > 0 && finalRemaining === 0
            ? "Discount Applied / Fully Paid"
            : totalDiscount > 0 && totalAdvance > 0
                ? "Advance & Discount Applied"
                : finalRemaining > 0 && totalAdvance > 0
                    ? "Advance Received"
                    : finalRemaining === 0
                        ? "Fully Paid"
                        : "Pending";

    const handleFiles = (e) => {
        const files = Array.from(e.target.files || []);
        setDocFiles((p) => [...p, ...files]);
        const mapped = files.map((f) => ({
            name: f.name,
            size: (f.size / 1024).toFixed(1) + " KB",
            type: f.type,
            url: URL.createObjectURL(f),
        }));
        setDocs((p) => [...p, ...mapped]);
        fileRef.current.value = "";
    };

    const removeDoc = async (i) => {
        console.log("Removed doc:", docs[i].name);
        setDocs((p) => p.filter((_, idx) => idx !== i));
        setDocFiles((p) => p.filter((_, idx) => idx !== i));
    };

    // Replace your current validate() function with this:

    const validate = (type = null) => {
        const e = {};

        // Skip guest detail validation for reservation
        const isReservation = type === "reserved";

        if (!isReservation) {
            if (!form.guest_name.trim()) e.guest_name = "Required";
            if (!form.phone.trim()) e.phone = "Required";
            if (!form.id_number.trim()) e.id_number = "Required";
        }

        // Date validation always required
        if (!form.check_in) e.date_range = "Required";
        if (!form.check_out) e.date_range = "Required";

        if (nights <= 0 && form.check_out) {
            e.date_range = "Check-out must be after check-in";
        }

        return e;
    };

    const buildFormData = (payload, docFiles = []) => {
        const formData = new FormData();
        const appendValue = (key, value) => {
            if (value === null || value === undefined) return;
            if (typeof value === "object" && !(value instanceof File)) {
                formData.append(key, JSON.stringify(value));
            } else {
                formData.append(key, value);
            }
        };
        Object.entries(payload).forEach(([key, value]) => appendValue(key, value));
        docFiles.forEach((file) => formData.append("documents", file));
        return formData;
    };

    const handleSubmit = async (type) => {
        console.log("Submitting with type:", type);

        const currentTime = dayjs().format("hh:mm:ss A");

        const pricing_summary = {
            booking_type: hourlyBook ? "hourly" : "daily",

            rate_per_night: room.total_price_per_day || 0,
            duration_nights: nights,

            rate_per_hour: room.total_price_per_hour || 0,
            duration_hours: hourlyBook ? totalHours : 0,

            base_total: baseTotal,
            extra_guests: extraGuests,
            extra_cost_per_night: extraCostPerNight,
            extra_total: extraTotal,

            ac_charge_total: acChargeTotal,
            ac_charge: acRequired ? room.ac_charge || 0 : 0,

            full_book: full_book,
            full_book_charge: fullBooking ? room.additional_24_hour || 0 : 0,

            total_amount: finalPayableTotal,
            paid_amount: paidValue,
            received_advance: receivedAdvance,
            remaining_payable: remainingPayable,
            discount_amount: discountAmount,
            amount_type: amountType,
            payment_status: paymentStatus,
            payment_rows: paymentRows,

            total_before_loyalty_discount: rawTotal,
            loyalty_discount_percent: loyaltyDiscountPercent,
            loyalty_discount_amount: loyaltyDiscountAmount,

            customer_gst: form?.customer_gst || "",
            gst_type: gstType,
            gst_percent: gstPercent,
            gst_amount: gstAmount,
            early_checkin_amount: earlyCheckinAmount,

            extra_child: extraChild,
            extra_child_cost_per_night: extraChildCostPerNight,
            extra_child_total: extraChildTotal,
            child_cost_per_person: childCostPerPerson,
        };

        console.log('form', form);
        console.log("pricing_summary", pricing_summary);
        console.log("form.phone", form.phone);

        if (type === "occupied") {
            if (!form?.guest_name?.trim()) {
                notify.error(
                    "Guest name is required for confirming booking. For reservations, you can confirm later."
                );
                return;
            }

            if (!form?.phone?.trim()) {
                notify.error(
                    "Phone number is required for confirming booking. For reservations, you can confirm later."
                );
                return;
            }
        }

        console.log("***", form);

        const safeStatus = typeof type === "string" && type.trim() !== "" ? type : null;

        const finalPayload = {
            ...form,
            room_id: navRoom.id,
            ac_required: acRequired,
            room_data: navRoom,
            // check_in_time: currentTime,
            // check_out_time: currentTime,
            pricing_summary,
            full_book: fullBooking,
            // status: type,
            ...(safeStatus ? { status: safeStatus } : {}),
            paid_amount: totalAdvance,
            payment_rows: paymentRows,
            // KEY: if this is a future reservation on an already-occupied room,
            // tell the backend NOT to change the room's current status
            // skip_room_status_update: isNewReservation ? true : false,
            skip_room_status_update: !isOnlineBookingView && isNewReservation,
        };

        const formData = buildFormData({ ...finalPayload }, docFiles);

        console.log("finalPayload__--", finalPayload);


        try {
            setLoading(true);
            const res = await fetch(
                ENDPOINTS.BOOKROOM, { method: "POST", body: formData }
            );
            const data = await res.json();
            if (data.status) {
                const exactSnapshot = {
                    bookId: data.book_room_id,
                    room,
                    form: { ...form },
                    nights,
                    total: finalPayableTotal,
                    grandTotal: finalPayableTotal,
                    paidAmount: paidValue,
                    receivedAdvance,
                    remainingPayable: finalRemaining,
                    discountAmount,
                    amountType,
                    paymentStatus,
                    pricing_summary,
                };

                setSuccessData(exactSnapshot);
                setIsNewReservation(false); // reset mode
                setSubmitted(true);
                setBookId(data.book_room_id);
            } else {
                alert("Booking failed: " + data.message);
            }
        } catch (err) {
            alert("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = async (type) => {
        // const e = validate();
        // if (Object.keys(e).length) { setErrors(e); return; }

        console.log("Submitting with form:", form);

        if (type === "occupied") {
            if (!form?.guest_name?.trim()) {
                notify.error(
                    "Guest name is required for confirming booking. For reservations, you can confirm later."
                );
                return;
            }

            if (!form?.phone?.trim()) {
                notify.error(
                    "Phone number is required for confirming booking. For reservations, you can confirm later."
                );
                return;
            }
        }


        const currentTimeStr = dayjs().format("hh:mm:ss A");

        const pricing_summary = {
            booking_type: hourlyBook ? "hourly" : "daily",

            rate_per_night: room.total_price_per_day || 0,
            duration_nights: nights,

            rate_per_hour: room.total_price_per_hour || 0,
            duration_hours: hourlyBook ? (totalHours * nights) : 0,

            base_total: baseTotal,
            extra_guests: extraGuests,
            extra_cost_per_night: extraCostPerNight,
            extra_total: extraTotal,

            ac_charge_total: acChargeTotal,
            ac_charge: acRequired ? room.ac_charge || 0 : 0,

            full_book: full_book,
            full_book_charge: fullBooking ? room.additional_24_hour || 0 : 0,

            total_amount: finalPayableTotal,
            paid_amount: paidValue,
            received_advance: receivedAdvance,
            remaining_payable: remainingPayable,
            discount_amount: discountAmount,
            amount_type: amountType,
            payment_status: paymentStatus,
            payment_rows: paymentRows,

            total_before_loyalty_discount: rawTotal,
            loyalty_discount_percent: loyaltyDiscountPercent,
            loyalty_discount_amount: loyaltyDiscountAmount,

            customer_gst: form?.customer_gst || "",
            gst_type: gstType,
            gst_percent: gstPercent,
            gst_amount: gstAmount,
            early_checkin_amount: earlyCheckinAmount,

            extra_child: extraChild,
            extra_child_cost_per_night: extraChildCostPerNight,
            extra_child_total: extraChildTotal,
            child_cost_per_person: childCostPerPerson,
        };

        console.log("pricing_summary@@@@@@@@@", pricing_summary);


        const existing_documents = docs
            .filter((d) => d.existing)
            .map((d) => `documents/${d.name}`);

        // Use selectedUpcoming if editing an upcoming booking, else use existingUser[0]
        // const sourceData = selectedUpcoming || existingUser?.[0] || {};
        const sourceData = selectedUpcoming || existingUser?.[0] || onlineBooking || {};

        const finalPayload = {
            ...form,
            ac_required: acRequired,
            book_room_id: sourceData.book_room_id || sourceData.br_id,
            book_log_id: sourceData.bl_id || sourceData.id,
            room_id: navRoom.id,
            room_data: room,
            pricing_summary,
            // status: type,
            ...(type ? { status: type } : {}),
            existing_documents,
            paid_amount: totalAdvance,
            payment_rows: paymentRows,
        };

        const formData = buildFormData(finalPayload, docFiles);

        console.log("finalPayload+++++++", finalPayload);




        try {
            setLoading(true);
            const res =
                await fetch(
                    ENDPOINTS.BOOKROOM, { method: "PATCH", body: formData }
                );
            const data = await res.json();
            console.log("data |--(*_*)--|", data);


            if (data.status) {
                const exactSnapshot = {
                    bookId: data.book_room_id,
                    room,
                    form: { ...form },
                    nights,
                    total: finalPayableTotal,
                    grandTotal: finalPayableTotal,
                    paidAmount: paidValue,
                    receivedAdvance,
                    remainingPayable: finalRemaining,
                    discountAmount,
                    amountType,
                    paymentStatus,
                    pricing_summary,
                };

                setSuccessData(exactSnapshot);

                notify.success("Booking updated successfully!");
                // fetchAllBookings();

                setSubmitted(true);
                setBookId(data.book_room_id);
            }

        } catch (err) {
            notify.error("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };
    // ── Check-Out handler: receives { status, note } from modal ──
    const handleCheckOut = async ({ status, note, form, act_checkout_time, act_check_out_date, difference_time, overdue_amount }) => {

        const log = { status, note };
        console.log("Check-out log:", log);
        console.log("Check-out form:", form);
        console.log("-|_(*_*)_|-", selectedUpcoming);


        try {
            setCheckOutLoading(true);
            const paylaod = {
                guest_status: status,
                note: note,
                status: 'available',

                // bl_id: form.bl_id,
                // br_id: form.br_id,
                bl_id: selectedUpcoming.bl_id,
                br_id: selectedUpcoming.br_id,
                room_id: selectedUpcoming.room_id,

                act_check_out_date: act_check_out_date,
                act_check_out_time: act_checkout_time, //currentTime(),
                difference_time: difference_time,
                update_at: formatDate(),
                overdue_amount: overdue_amount ?? 0,

            }
            console.log("payload", paylaod);

            const res = await BooknLogService.checkOut(paylaod);

            console.log("res for checkout", res);

            if (res.status) {
                notify.success(res.message);
                setCheckOutModalOpen(false);
                navigate(-1);
            } else {
                notify.error(res.message || "Check-out failed");
            }
        } catch (err) {
            notify.error("Something went wrong.");
        } finally {
            setCheckOutLoading(false);
        }

        // For now just close modal and notify
        setCheckOutModalOpen(false);
        notify.success("Check-out logged successfully!");
    };

    const handleMaintenance = async (status) => {
        try {
            const request = await RoomServices.editRoom(navRoom.id, { status: status });
            if (request.status) {
                notify.success(`Room marked as ${status}`);
                navigate('/book-room')
            } else {
                notify.error(`Failed to mark room as ${status}.`);
            }

        } catch (error) {
            console.error(error);
            notify.error("Something went wrong.");
        }
    }


    const safeDate = (value) => {
        if (!value) return null;

        if (dayjs.isDayjs(value)) {
            return value.isValid() ? value : null;
        }

        const parsed = dayjs(value, ["YYYY-MM-DD", "DD-MM-YYYY"], true);

        return parsed.isValid() ? parsed : null;
    };

    const selectedCheckIn = safeDate(form.check_in);
    const selectedCheckOut = safeDate(form.check_out);


    const enabledRange = {
        start: safeDate(form.check_in),
        end: safeDate(form.check_out),
    };

    // const [enabledRange, setEnabledRange] = useState({
    //     start: selectedCheckIn,
    //     end: selectedCheckOut,
    // });


    const grandTotal = total;
    // const totalPaid = paidAmount;
    const totalPaid = totalAdvance;

    if (!canViewModule(MODULE_KEY)) {
        return <Empty description="No permission to view this page" />;
    }

    if (submitted)


        return (

            <SuccessScreen
                bookId={successData?.bookId || bookId}
                room={successData?.room || room}
                form={successData?.form || form || onlineBooking}
                nights={successData?.nights ?? nights}
                // total={successData?.total ?? finalPayableTotal}
                total={successData?.total ?? finalPayableTotal}
                grandTotal={successData?.grandTotal ?? finalPayableTotal}
                paidAmount={successData?.paidAmount ?? paidValue}
                receivedAdvance={successData?.receivedAdvance ?? receivedAdvance}
                remainingPayable={successData?.remainingPayable ?? remainingPayable}
                discountAmount={successData?.discountAmount ?? discountAmount}
                amountType={successData?.amountType ?? amountType}
                paymentStatus={successData?.paymentStatus ?? paymentStatus}
                loyaltyDiscountPercent={loyaltyDiscountPercent}
                loyaltyDiscountAmount={loyaltyDiscountAmount}
                pricing_summary={successData?.pricing_summary || {
                    booking_type: hourlyBook ? "hourly" : "daily",
                    rate_per_night: room.total_price_per_day || 0,
                    duration_nights: nights,
                    rate_per_hour: room.total_price_per_hour || 0,
                    duration_hours: hourlyBook ? totalHours : 0,
                    base_total: baseTotal,
                    extra_guests: extraGuests,
                    extra_cost_per_night: extraCostPerNight,
                    extra_total: extraTotal,
                    ac_charge_total: acChargeTotal,
                    ac_charge: acRequired ? room.ac_charge || 0 : 0,
                    full_book: full_book,
                    full_book_charge: fullBooking ? room.additional_24_hour || 0 : 0,
                    total_amount: finalPayableTotal,
                    paid_amount: paidValue,
                    received_advance: receivedAdvance,
                    remaining_payable: finalRemaining,
                    discount_amount: discountAmount,
                    amount_type: amountType,
                    payment_status: paymentStatus,
                    payment_rows: paymentRows,
                    total_before_loyalty_discount: rawTotal,
                    loyalty_discount_percent: loyaltyDiscountPercent,
                    loyalty_discount_amount: loyaltyDiscountAmount,
                    customer_gst: form?.customer_gst || "",
                    gst_type: gstType,
                    gst_percent: gstPercent,
                    gst_amount: gstAmount,
                    early_checkin_amount: earlyCheckinAmount,
                }}
                onBack={onBack}
                gst={gst}
                gstType={gstType}
                gstPercent={gstPercent}
                gstAmount={gstAmount}
                headerImg={`${ENDPOINTS.IMG_HEADER}${headerImg}`}
                headera4Img={`${ENDPOINTS.IMG_HEADER}${a4PdfHeaderImg}`}
                footerImg={`${ENDPOINTS.IMG_HEADER}${footerImg}`}
                hourlyBook={hourlyBook}
                totalHours={totalHours}
                overdue_amount={currentPricing?.overdue_amount || 0}
                early_checkin_amount={earlyCheckinAmount || currentPricing?.early_checkin_amount || 0}
                full_book={full_book}
                finalRemainingPayable={successData?.remainingPayable ?? finalRemaining}

            />
        );



    return (
        <>

            <Card

                title={

                    <div style={{ ...css.cardHeader, padding: '15px 0 15px 0' }}>
                        <div
                            style={css.backBtn}
                            onClick={() => navigate(-1)}
                            onMouseEnter={e => {
                                e.currentTarget.style.background = T.accentSoft;
                                e.currentTarget.style.transform = "scale(1.06)";
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.background = T.accentLight;
                                e.currentTarget.style.transform = "scale(1)";
                            }}
                        >
                            <ArrowLeftOutlined />
                        </div>
                        <div>
                            <div style={css.pageTitle}>Room Booking</div>
                            <div style={{ fontSize: 11, color: T.textMuted, marginTop: 1 }}>
                                Manage booking & reservation of room
                            </div>
                        </div>
                    </div>
                }
                extra={
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>

                        {room.status === "occupied" && (
                            <>
                                <Tooltip title={!canCreateModule(MODULE_KEY) ? "No permission to Service Request" : ""}>
                                    <Button
                                        onClick={() => setServiceReqModalOpen(true)}
                                        type="primary"
                                        size="middle"
                                        disabled={!canCreateModule(MODULE_KEY)}
                                    >
                                        Service Request
                                    </Button>
                                </Tooltip>
                            </>
                        )}

                        <Divider type="vertical" style={{ borderColor: T.border }} />
                        {room.status === "available" && (
                            <Popconfirm
                                title="Mark as Maintenance"
                                description="This room is under maintenance. Are you sure?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    console.log("Confirmed");
                                    handleMaintenance('maintenance');
                                }}
                            >
                                <Button
                                    danger
                                    icon={<ToolOutlined style={{ fontSize: 20, color: "red" }} />}
                                >
                                    Maintenance
                                </Button>
                            </Popconfirm>
                        )}

                    </div>
                }
            >
                <div style={styles.layout}>
                    {/* ══════ LEFT — Room Details ══════ */}
                    <div style={styles.leftPanel}>

                        <SectionCard title="Room Details" icon={<HomeOutlined />}
                            extra={
                                <Button
                                    onClick={() => navigate('/room/history', { state: { room } })}


                                    color="purple" variant="text">
                                    History
                                </Button>
                            }
                        >
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                                <div>
                                    <div style={{ fontSize: 20, fontWeight: 700, color: T.text, letterSpacing: "-0.5px" }}>{room?.room_name}</div>
                                    <div style={{ fontSize: 12, color: T.textMuted, marginTop: 2 }}>Room #{room?.room_number}</div>
                                </div>
                                <StatusBadge cfg={cfg} />
                            </div>

                            {room?.description && (
                                <div
                                    style={{
                                        fontSize: 12.5, color: T.textSub, lineHeight: 1.65,
                                        padding: "10px 12px", background: T.bg,
                                        borderRadius: T.radiusSm, border: `1px solid ${T.border}`,
                                        marginBottom: 14, wordBreak: "break-word",
                                    }}
                                    dangerouslySetInnerHTML={{ __html: room.description }}
                                />
                            )}

                            <div style={{ height: 1, background: T.border, margin: "14px 0" }} />

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 4 }}>
                                <DetailItem icon={<AppstoreOutlined />} label="Room Type" value={room?.room_type} />
                                <DetailItem icon={<TeamOutlined />} label="Max Occupancy" value={room?.max_occupancy ? `${room.max_occupancy} guests` : "—"} />
                                <DetailItem icon={<HomeOutlined />} label="Floor" value={room?.floor} />
                                <DetailItem icon={<StarFilled />} label="Status" value={room?.status} />
                            </div>

                            <Divider />
                            <div style={{ fontSize: 11, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 8 }}>Amenities</div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                {amenities.map((a) => (<span key={a} style={styles.amenityTag}>{a}</span>))}
                            </div>

                            <Divider />
                            <div style={{ fontSize: 11, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 10 }}>Pricing Summary</div>


                            {hourlyBook ? (
                                <>
                                    <div style={styles.priceRow}>
                                        <span>Rate per Hour</span>
                                        <span style={{ fontWeight: 600 }}>
                                            ₹{Number(room.total_price_per_hour || 0).toLocaleString()}
                                        </span>
                                    </div>

                                    <div style={styles.priceRow}>
                                        <span>Total Hours</span>
                                        <span style={{ fontWeight: 600 }}>
                                            {totalHours} {totalHours === 1 ? "hour" : "hours"}
                                        </span>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div style={styles.priceRow}>
                                     <span>Rate per night</span>
<span style={{ fontWeight: 600 }}>
    ₹{Number(room.total_price_per_day || room.price_per_day || 0).toLocaleString()}
</span>
                                    </div>

                                </>
                            )}

                            <div style={styles.priceRow}>
                                <span>Duration</span>
                                <span style={{ fontWeight: 600 }}>
                                    {onlineBooking
                                        ? (() => {
                                            const ps = JSON.parse(onlineBooking.pricing_summary);
                                            const n = ps.duration_nights;
                                            return `${n} ${n === 1 ? "night" : "nights"}`;
                                        })()
                                        : `${nights || "—"} ${nights === 1 ? "night" : "nights"}`
                                    }
                                </span>
                            </div>

                            {onlineBooking && (
                                <div style={styles.priceRow}>
                                    <span>Base Total</span>
                                    <span style={{ fontWeight: 600 }}>
                                        ₹{JSON.parse(onlineBooking.pricing_summary).base_total?.toLocaleString()}
                                    </span>
                                </div>
                            )}


                            {earlyCheckinAmount > 0 && (
                                <div style={styles.priceRow}>
                                    <span>Early Check-in Charge</span>
                                    <span style={{ fontWeight: 600, color: "#cf1322" }}>
                                        +₹{earlyCheckinAmount.toLocaleString()}
                                    </span>
                                </div>
                            )}

                            {room.ac_charge > 0 && (
                                <div style={styles.priceRow}>
                                    <span>
                                        AC Charge{" "}
                                        <Tooltip title="Check 'AC Required' in booking details to add this charge">
                                            <InfoCircleOutlined style={{ marginLeft: 6, color: "#1890ff", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                    <span style={{ fontWeight: 600, color: acRequired ? "#237804" : "#999" }}>
                                        {onlineBooking
                                            ? `₹${JSON.parse(onlineBooking.pricing_summary).ac_charge_per_night?.toLocaleString()} / night`
                                            : `₹${room.ac_charge?.toLocaleString()} / Duration`
                                        }
                                        {!acRequired && " (optional)"}
                                    </span>
                                </div>
                            )}

                            {room.additional_24_hour > 0 && (
                                <div style={styles.priceRow}>
                                    <span>
                                        24 Hour Charge{" "}
                                        <Tooltip title="Check '24H Required' in booking details to add this charge">
                                            <InfoCircleOutlined style={{ marginLeft: 6, color: "#1890ff", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                    <span style={{ fontWeight: 600, color: fullBooking ? "#237804" : "#999" }}>
                                        {onlineBooking
                                            ? `₹${JSON.parse(onlineBooking.pricing_summary).additional_24_hour?.toLocaleString()}`
                                            : `₹${room.additional_24_hour?.toLocaleString()}`
                                        }
                                        {!fullBooking && " (optional)"}
                                    </span>
                                </div>
                            )}

                            {/* AC Total — only show for online booking */}
                            {onlineBooking && acRequired && (
                                <div style={styles.priceRow}>
                                    <span>AC Total</span>
                                    <span style={{ fontWeight: 600 }}>
                                        ₹{JSON.parse(onlineBooking.pricing_summary).ac_total?.toLocaleString()}
                                    </span>
                                </div>
                            )}


                            {/* Extra Guests */}
                            {(onlineBooking
                                ? JSON.parse(onlineBooking.pricing_summary).extra_guests > 0
                                : extraGuests > 0
                            ) && (
                                    <>
                                        <div style={styles.priceRow}>
                                            <span>
                                                Extra Guests ({onlineBooking
                                                    ? JSON.parse(onlineBooking.pricing_summary).extra_guests
                                                    : extraGuests})
                                            </span>
                                            <span style={{ fontWeight: 600 }}>
                                                ₹{(onlineBooking
                                                    ? JSON.parse(onlineBooking.pricing_summary).extra_cost_per_night
                                                    : extraCostPerNight
                                                )?.toLocaleString()} / night
                                            </span>
                                        </div>
                                        <div style={styles.priceRow}>
                                            <span>Extra Guest Total</span>
                                            <span style={{ fontWeight: 600 }}>
                                                ₹{(onlineBooking
                                                    ? JSON.parse(onlineBooking.pricing_summary).extra_total
                                                    : extraTotal
                                                )?.toLocaleString()}
                                            </span>
                                        </div>
                                    </>
                                )}

                            {extraChild > 0 && (
                                <>
                                    <div style={styles.priceRow}>
                                        <span>Extra Child ({extraChild})</span>
                                        <span style={{ fontWeight: 600 }}>
                                            ₹{extraChildCostPerNight.toLocaleString()} / night
                                        </span>
                                    </div>

                                    <div style={styles.priceRow}>
                                        <span>Extra Child Total</span>
                                        <span style={{ fontWeight: 600 }}>
                                            ₹{extraChildTotal.toLocaleString()}
                                        </span>
                                    </div>
                                </>
                            )}

                            {loyaltyDiscountPercent > 0 && (
                                <div style={styles.priceRow}>
                                    <span>
                                        Loyalty Member Discount ({loyaltyDiscountPercent}%)
                                        <Tooltip title="This discount applies for loyalty membership.">
                                            <InfoCircleOutlined
                                                style={{ marginLeft: 6, color: "#1890ff", cursor: "pointer" }}
                                            />
                                        </Tooltip>
                                    </span>

                                    <span style={{ fontWeight: 700, color: "#cf1322" }}>
                                        -₹{loyaltyDiscountAmount.toLocaleString()}
                                    </span>
                                </div>
                            )}

                            {gstPercent > 0 && (
                                <>
                                    <div style={styles.priceRow}>
                                        <span style={{ fontWeight: 600 }}>GST Type</span>

                                        <Switch
                                            checked={gstType === "inclusive"}
                                            checkedChildren="Inclusive"
                                            unCheckedChildren="Exclusive"
                                            onChange={(checked) => {
                                                setGstType(checked ? "inclusive" : "exclusive");

                                            }}
                                        />
                                    </div>

                                    <div style={styles.priceRow}>
                                        <span>
                                            GST ({gstPercent}%)
{gstType === "inclusive"
    ? " (Added to Total)"
    : " (Included in Total)"}
                                        </span>

                                        <span
                                            style={{
                                                fontWeight: 700,
                                             color: gstType === "inclusive" ? "#237804" : "#cf1322",
                                            }}
                                        >
                                            ₹{gstAmount.toLocaleString()}
                                        </span>
                                    </div>
                                </>
                            )}

                            {/* Total Amount */}
                            <div style={{ ...styles.priceRow, marginTop: 10, padding: "10px 14px", background: "#f6ffed", borderRadius: 8, border: "1px solid #b7eb8f" }}>
                                <span style={{ fontWeight: 700, color: "#237804" }}>Total Amount</span>
                                <span style={{ fontWeight: 800, fontSize: 18, color: "#237804" }}>
                                    ₹{finalPayableTotal.toLocaleString()}
                                </span>
                            </div>

                            <div
                                style={{
                                    marginTop: 10,
                                    padding: "14px",
                                    background: "#f6ffed",
                                    borderRadius: 8,
                                    border: "1px solid #b7eb8f",
                                }}
                            >
                                <div style={{ fontWeight: 800, marginBottom: 10, color: "#237804" }}>
                                    Payment / Discount Details
                                </div>

                                {paymentRows.length === 0 && (
                                    <div style={{ fontSize: 12, color: "#888", marginBottom: 10 }}>
                                        No advance or discount added.
                                    </div>
                                )}

                      {paymentRows.map((row) => (
                                            <div
                                                key={row.key}
                                                style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: 4,
                                                    marginBottom: 8,
                                                    alignItems: "center",
                                                }}
                                            >
                                   <Select
                                            style={{ width: "100px" }}
                                            value={row.type}
                                            options={[
                                                { label: "Advance", value: "advance" },
                                                { label: "Discount", value: "discount" },
                                                { label: "Full Pay", value: "full_pay" },
                                            ]}
                                            onChange={(v) => updatePaymentRow(row.key, "type", v)}
                                        />

                                        {/* <input
                                            type="number"
                                            min="0"
                                            value={row.amount}
                                            onChange={(e) =>
                                                updatePaymentRow(
                                                    row.key,
                                                    "amount",
                                                    Number(e.target.value || 0)
                                                )
                                            }
                                            style={{
                                                width: "100%",
                                                padding: "6px 12px",
                                                textAlign: "right",
                                                background: "#fff",
                                                border: "1px solid #d9d9d9",
                                                borderRadius: "6px",
                                            }}
                                        /> */}
                                        <input
                                            type="number"
                                            min="0"
                                            value={row.amount}
                                            readOnly={row.type === "full_pay"}
                                            onChange={(e) =>
                                                updatePaymentRow(
                                                    row.key,
                                                    "amount",
                                                    Number(e.target.value || 0)
                                                )
                                            }
                                      style={{
                                                width: "80px",
                                                padding: "6px 8px",
                                                textAlign: "right",
                                                background: row.type === "full_pay" ? "#f5f5f5" : "#fff",
                                                border: "1px solid #d9d9d9",
                                                borderRadius: "6px",
                                            }}
                                        />
<select
                                            value={row.mode}
                                            onChange={(e) => updatePaymentRow(row.key, "mode", e.target.value)}
                                       style={{
                                                flex: 1,
                                                minWidth: 80,
                                                padding: "5px 6px",
                                                border: "1px solid #d9d9d9",
                                                borderRadius: 6,
                                                background: "#fff",
                                                fontSize: 12,
                                                color: "#333",
                                                height: 34,
                                                appearance: "auto",
                                                WebkitAppearance: "menulist",
                                                MozAppearance: "menulist",
                                                outline: "none",
                                                cursor: "pointer",
                                            }}
                                        >
                                            {["Cash", "UPI", "Card", "Bank Transfer", "Advance"].map((m) => (
                                                <option key={m} value={m}>{m}</option>
                                            ))}
                                        </select>
                                        <Button
                                            danger
                                            type="text"
                                            icon={<DeleteRowOutlined />}
                                            onClick={() => removePaymentRow(row.key)}
                                        />
                                    </div>
                                ))}

                                <Space style={{ marginTop: 8, marginBottom: 10 }} wrap>
                                    <Button
                                        size="small"
                                        type="primary"
                                        disabled={finalRemaining <= 0}
                                        onClick={() => addPaymentRow("advance")}
                                    >
                                        + Add Payment
                                    </Button>

                                    <Button
                                        size="small"
                                        disabled={finalRemaining <= 0}
                                        onClick={() => addPaymentRow("discount")}
                                    >
                                        + Add Discount
                                    </Button>
                                </Space>

                                <Divider />

                             {gstPercent > 0 && gstType === "inclusive" && (
                                    <>
                                        <div style={styles.priceRow}>
                                            <span>CGST ({gstPercent / 2}%)</span>
                                            <b>₹{(gstAmount / 2).toLocaleString()}</b>
                                        </div>
                                        <div style={styles.priceRow}>
                                            <span>SGST ({gstPercent / 2}%)</span>
                                            <b>₹{(gstAmount / 2).toLocaleString()}</b>
                                        </div>
                                    </>
                                )}

                                <div style={styles.priceRow}>
                                    <span>Total Discount</span>
                                    <b style={{ color: "#cf1322" }}>₹{totalDiscount.toLocaleString()}</b>
                                </div>

                                <div style={styles.priceRow}>
                                    <span>Total Paid</span>
                                    <b>₹{totalAdvance.toLocaleString()}</b>
                                </div>

                                <div style={styles.priceRow}>
                                    <span>Remaining Payable</span>
                                    <b>₹{finalRemaining.toLocaleString()}</b>
                                </div>

                                <div style={styles.priceRow}>
                                    <span>Payment Status</span>
                                    <b>{paymentStatus}</b>
                                </div>
                            </div>


                        </SectionCard>
                    </div>

                    {/* ══════ RIGHT — Booking Form ══════ */}
                    <div style={styles.rightPanel}>

                        {room.status === "maintenance" ? (<>

                            <Result
                                icon={
                                    <Image
                                        src={maintance}
                                        preview={false}
                                        alt="Room Maintenance"
                                        style={{ width: "70%", height: "auto" }}
                                    />
                                }
                                title="Room under maintenance!"
                                extra={

                                    <Popconfirm
                                        title="Mark as Available"
                                        description="This room will be marked as available. Are you sure?"
                                        okText="Yes"
                                        cancelText="No"
                                        onConfirm={() => {
                                            handleMaintenance('available');
                                        }}
                                    >
                                        <Button size="large" color="pink" variant="filled">
                                            Make it Available
                                        </Button>
                                    </Popconfirm>

                                }
                            />
                        </>) : (<>

                            <UpcomingBookingsList
                                check_in_date={check_in_date}
                                bookings={allBookings}
                                onSelect={handleUpcomingSelect}
                                selectedId={selectedUpcoming?.bl_id}
                            // setPaymentRows={setPaymentRows}
                            />


                            <SectionCard
                                title={<Space>
                                    Guest Information

                                </Space>}
                                icon={<UserOutlined />}

                                extra={
                                    <Space>
                                        {
                                            showActions
                                            // room.status?.toLowerCase() != "available" 
                                            && (
                                                <>
                                                    {/* Show New Reservation only if existing user is present */}
                                                    {/* {existingUser?.length > 0 && ( */}
                                                    <Tooltip title={!canCreateModule(MODULE_KEY) && !isNewReservation ? "No permission to create reservation" : ""}>
                                                        <Button
                                                            size="large"
                                                            icon={isNewReservation ? <CloseOutlined /> : <PlusOutlined />}
                                                            disabled={!canCreateModule(MODULE_KEY) && !isNewReservation}
                                                            onClick={() => {
                                                                if (isNewReservation) {
                                                                    setSelectedUpcoming(null);
                                                                    setIsNewReservation(false);
                                                                    if (existingUser?.length > 0) {
                                                                        const u = existingUser[0];
                                                                        // setForm({
                                                                        setFormWithAllowedRange({
                                                                            ...emptyForm, ...u, guests: Number(u.guests) || 1
                                                                        });
                                                                    } else {
                                                                        setForm(emptyForm);
                                                                    }
                                                                } else {
                                                                    setIsNewReservation(true);
                                                                    // setForm({
                                                                    setFormWithAllowedRange({
                                                                        ...emptyForm,
                                                                        check_in: tomorrowDate.format("YYYY-MM-DD"),
                                                                        check_out: tomorrowDate.add(1, "day").format("YYYY-MM-DD"),
                                                                    });
                                                                    setDocs([]);
                                                                    setDocFiles([]);
                                                                    setErrors({});
                                                                }
                                                            }}
                                                            color={isNewReservation ? "default" : "primary"}
                                                            variant="filled"
                                                        >
                                                            {isNewReservation ? "Close" : "New Reservation"}
                                                        </Button>
                                                    </Tooltip>
                                                    {/* )} */}

                                                    <Space>
                                                        <Tooltip title={!canUpdateModule(MODULE_KEY) ? "No permission to Cancel Reservation" : ""}>
                                                            <Button
                                                                size="large"
                                                                icon={<CloseCircleOutlined />}
                                                                onClick={() => setCancelCheckModalOpen(true)}
                                                                color="purple"
                                                                variant="filled"
                                                                disabled={!canUpdateModule(MODULE_KEY)}
                                                            >
                                                                Cancel Reservation
                                                            </Button>
                                                        </Tooltip>

                                                        <Tooltip title={!canCreateModule(MODULE_KEY) ? "No permission to Check-In" : ""}>
                                                            <Button
                                                                color="primary"
                                                                variant="filled"
                                                                icon={<LoginOutlined />}
                                                                size="large"
                                                                disabled={!canCreateModule(MODULE_KEY)}
                                                                onClick={() => handleUpdate("occupied")}
                                                            >
                                                                Check-In
                                                            </Button>
                                                        </Tooltip>
                                                    </Space>
                                                    <Tooltip title={!canCreateModule(MODULE_KEY) ? "No permission to Check Out" : ""}>
                                                        <Button
                                                            size="large"
                                                            color="danger"
                                                            disabled={
                                                                !canCreateModule(MODULE_KEY) ||   // ← changed from canDeleteModule
                                                                selectedUpcoming?.status?.toLowerCase() === "check_out" ||
                                                                selectedUpcoming?.status?.toLowerCase() === "exited"
                                                            }
                                                            variant="filled"
                                                            icon={<LogoutOutlined />}
                                                            onClick={() => setCheckOutModalOpen(true)}
                                                        >
                                                            Check Out
                                                        </Button>
                                                    </Tooltip>
                                                </>
                                            )}
                                    </Space>
                                }
                            >
                                {
                                    // existingUser?.length > 0 &&
                                    !isNewReservation && (
                                        <>
                                            <CheckInOutCard form={form} />
                                            <Divider style={{ margin: "14px 0" }} />
                                        </>
                                    )}

                                {!selectedUpcoming && allBookings.length > 0 && (
                                    <div
                                        style={{
                                            background: "#e6f4ff",
                                            border: "1px solid #91caff",
                                            borderRadius: 8,
                                            padding: "10px 14px",
                                            marginBottom: 14,
                                            fontSize: 13,
                                            color: "#0050b3",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                        }}
                                    >
                                        <CalendarOutlined style={{ fontSize: 16 }} />
                                        Please select reservations
                                    </div>
                                )}

                                <div style={{ ...styles.formGrid, gridTemplateColumns: "1fr 1fr" }}>

                                    {/* <FormField label="Phone Number" >
                                        <Input prefix={<PhoneOutlined />} placeholder="98765 67891" value={form.phone}
                                            onChange={(v) => { set("phone", v); }} />
                                    </FormField> */}
                                    <FormField label="Phone Number">
                                        <div style={styles.inputWrap}>
                                            <span style={styles.inputPrefix}>
                                                <PhoneOutlined />
                                            </span>

                                            <input
                                                className="custom-input"
                                                list="customer-phone-list"
                                                placeholder="Enter Guest Phone No."
                                                value={form.phone || ""}
                                                onChange={(e) => handlePhoneChange(e.target.value)}
                                                style={{ ...styles.input, paddingLeft: 32 }}
                                            />

                                            <datalist id="customer-phone-list">
                                                {exCustomer.map((cust) => (
                                                    <option key={cust.id || cust.phone} value={cust.phone}>
                                                        {cust.guest_name ? `${cust.guest_name} - ${cust.phone}` : cust.phone}
                                                    </option>
                                                ))}
                                            </datalist>
                                        </div>
                                    </FormField>

                                    <FormField label="Full Name" >
                                        <Input prefix={<UserOutlined />} placeholder="Enter Guest Name" value={form.guest_name}
                                            onChange={(v) => { set("guest_name", v); }} />
                                    </FormField>

                                    <FormField label="Customer GST" >
                                        <Input prefix={<InfoOutlined />} placeholder="Enter Guest GSTIN***" value={form.customer_gst}
                                            onChange={(v) => { set("customer_gst", v); }} />
                                    </FormField>


                                    <FormField label="Email Address">
                                        <Input prefix={<MailOutlined />} placeholder="Enter Guest Email" value={form.email} onChange={(v) => set("email", v)} />
                                    </FormField>
                                    <FormField label="ID Type">
                                        <Select value={form.id_type} options={["Aadhaar", "Passport", "Driving License", "Voter ID", "PAN Card"]} onChange={(v) => set("id_type", v)} />
                                    </FormField>
                                    <FormField label="ID Number" >
                                        <Input prefix={<IdcardOutlined />} placeholder="Enter ID number" value={form.id_number}
                                            onChange={(v) => { set("id_number", v); setErrors((p) => ({ ...p, id_number: "" })); }} />
                                    </FormField>
                                    <FormField label="Address" span={2}>
                                        <Textarea placeholder="Full address of the guest" value={form.address} onChange={(v) => set("address", v)} rows={2} />
                                    </FormField>
                                </div>
                            </SectionCard>

                            <SectionCard title="Booking Details" icon={<CalendarOutlined />}
                                extra={
                                    <Space>
                                        <FormField label=" " span={1}>
                                            <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", marginTop: 8 }}>
                                                <input
                                                    type="checkbox"
                                                    checked={acRequired}
                                                    onChange={(e) => setAcRequired(e.target.checked)}
                                                    style={{ width: 16, height: 16, cursor: "pointer" }}
                                                />
                                                <span style={{ fontSize: 13, fontWeight: 500 }}>AC Required</span>
                                                {room.ac_charge > 0 && (
                                                    <span style={{ fontSize: 12, color: "#888" }}>(+₹{room.ac_charge}/stay)</span>
                                                )}
                                            </label>
                                        </FormField>

                                        <FormField label=" " span={1}>
                                            <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", marginTop: 8 }}>
                                                <input
                                                    type="checkbox"
                                                    checked={hourlyBook}
                                                    onChange={(e) => {
                                                        setHourlyBook(e.target.checked)
                                                        setFullBooking(false)
                                                    }}
                                                    style={{ width: 16, height: 16, cursor: "pointer" }}
                                                />
                                                <span style={{ fontSize: 13, fontWeight: 500 }}>Hourly Room Book</span>
                                            </label>
                                        </FormField>

                                        <FormField label=" " span={1}>
                                            <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", marginTop: 8 }}>
                                                <input
                                                    type="checkbox"
                                                    checked={fullBooking}
                                                    onChange={(e) => {
                                                        setFullBooking(e.target.checked)
                                                        setHourlyBook(false)
                                                    }}
                                                    style={{ width: 16, height: 16, cursor: "pointer" }}
                                                />
                                                <span style={{ fontSize: 13, fontWeight: 500 }}>Book For 24 Hours</span>
                                            </label>
                                        </FormField>

                                    </Space>
                                }
                            >
                                <div
                                    style={{ ...styles.formGrid, gridTemplateColumns: "1fr 1fr 1fr" }}
                                >

                                    <FormField label={`Stay Duration ${nights ? `(${nights} ${nights === 1 ? "night" : "nights"})` : ""}`} required error={errors.date_range} span={1}>

                                        <RangePicker
                                            style={{ width: "100%", height: 38 }}
                                            value={
                                                selectedCheckIn && selectedCheckOut
                                                    ? [selectedCheckIn, selectedCheckOut]
                                                    : null
                                            }
                                            onChange={(dates) => {
                                                if (!dates || !dates[0] || !dates[1]) {
                                                    setForm((p) => ({
                                                        ...p,
                                                        check_in: "",
                                                        check_out: "",
                                                    }));
                                                    return;
                                                }

                                                setForm((p) => ({
                                                    ...p,
                                                    check_in: dates[0].format("YYYY-MM-DD"),
                                                    check_out: dates[1].format("YYYY-MM-DD"),
                                                }));

                                                const nextDate = dates[1]?.format("YYYY-MM-DD")
                                                    ? dayjs(dates[1].format("YYYY-MM-DD"))
                                                        .subtract(1, "day")
                                                        .format("YYYY-MM-DD")
                                                    : null;

                                                getRoomByPrice(dates[0].format("YYYY-MM-DD"), nextDate, navRoom.id)

                                                setErrors((p) => ({ ...p, date_range: "" }));
                                            }}

                                            disabledDate={(current) => {
                                                if (!current) return false;

                                                const allowedStart = safeDate(activeAllowedRange.start);
                                                const allowedEnd = safeDate(activeAllowedRange.end);

                                                // Never disable current loaded booking range
                                                if (
                                                    allowedStart &&
                                                    allowedEnd &&
                                                    current.isBetween(allowedStart, allowedEnd, "day", "[]")
                                                ) {
                                                    return false;
                                                }

                                                if (current.isBefore(dayjs().startOf("day"), "day")) {
                                                    return true;
                                                }

                                                if (isNewReservation && existingUser?.length > 0) {
                                                    const u = existingUser[0];

                                                    const occStart = safeDate(u.check_in);
                                                    const occEnd = safeDate(u.check_out);

                                                    if (
                                                        occStart &&
                                                        occEnd &&
                                                        current.isBetween(occStart, occEnd, "day", "[]")
                                                    ) {
                                                        return true;
                                                    }
                                                }

                                                return reservedRanges.some(({ start, end }) => {
                                                    const s = safeDate(start);
                                                    const e = safeDate(end);

                                                    if (!s || !e) return false;

                                                    return current.isBetween(s, e, "day", "[]");
                                                });
                                            }}
                                            format="DD-MM-YYYY"
                                            allowClear
                                        />
                                    </FormField>

                                    <FormField label="Check-in Time" span={1}>
                                        <TimePicker
                                            style={{ width: "100%", height: 38 }}
                                            format="hh:mm A"
                                            use12Hours
                                            value={
                                                form.check_in_time &&
                                                    dayjs(form.check_in_time, "hh:mm A").isValid()
                                                    ? dayjs(form.check_in_time, "hh:mm A")
                                                    : defaultCheckInTime?.isValid?.()
                                                        ? defaultCheckInTime
                                                        : null
                                            }
                                            onChange={(time, timeString) =>
                                                set("check_in_time", timeString || null)
                                            }
                                            allowClear
                                        />
                                    </FormField>

                                    <FormField label="Check-out Time" span={1}>
                                        {/* <TimePicker
                                            style={{ width: "100%", height: 38 }}
                                            format="hh:mm A"
                                            use12Hours
                                            value={form.check_out_time ? dayjs(form.check_out_time, "hh:mm A") : defaultCheckOutTime}
                                            onChange={(time, timeString) => set("check_out_time", timeString)}
                                            allowClear
                                        /> */}
                                        <TimePicker
                                            style={{ width: "100%", height: 38 }}
                                            format="hh:mm A"
                                            use12Hours
                                            value={
                                                form.check_out_time &&
                                                    dayjs(form.check_out_time, "hh:mm A").isValid()
                                                    ? dayjs(form.check_out_time, "hh:mm A")
                                                    : defaultCheckOutTime?.isValid?.()
                                                        ? defaultCheckOutTime
                                                        : null
                                            }
                                            onChange={(time, timeString) =>
                                                set("check_out_time", timeString || null)
                                            }
                                            allowClear
                                        />
                                    </FormField>

                                    <FormField span={2}>

                                        <Space size={34} wrap>
                                            <FormField label="Adults" span={1}>
                                                <NumberInput
                                                    value={form.guests}
                                                    min={1}
                                                    onChange={(v) => {
                                                        if (v + (form.child || 0) > max_persona) {
                                                            notify.info(`You cannot add more guests. The maximum occupancy for this room is ${max_persona} guests.`);
                                                            return;
                                                        }
                                                        set("guests", v);
                                                    }}
                                                />
                                            </FormField>

                                            {/* <FormField label="Child" span={1}>
                                                <NumberInput
                                                    value={form.child ?? 0}
                                                    min={0}
                                                    onChange={(v) => {
                                                        if (v + (form.guests || 0) > max_persona) {
                                                            notify.info("Max room limit reached!");
                                                            return;
                                                        }
                                                        set("child", v);
                                                    }}
                                                />
                                            </FormField> */}

                                            {/* {form.child &&( */}

                                            <FormField label="Child" span={1}>
                                                <NumberInput
                                                    value={form.child ?? 0}
                                                    min={0}
                                                    disabled={!Number(room.child_cost_per_person)}
                                                    onChange={(v) => {
                                                        if (!Number(room.child_cost_per_person)) {
                                                            notify.info("Child charges are not configured for this room. Please update them in Manage Room.");
                                                            return;
                                                        }

                                                        if (v + (form.guests || 0) > max_persona) {
                                                            notify.info(`You cannot add more guests. The maximum occupancy for this room is ${max_persona} guests.`);
                                                            return;
                                                        }

                                                        setForm((prev) => ({
                                                            ...prev,
                                                            child: v,
                                                            child_age: Array.from({ length: v }, (_, i) => ({
                                                                name: `child-${i + 1} age`,
                                                                age: prev.child_age?.[i]?.age ?? 0,
                                                            })),
                                                        }));
                                                    }}
                                                />
                                            </FormField>
                                            {/* )} */}

                                            {Array.from({ length: Number(form.child || 0) }, (_, i) => (
                                                <FormField key={i} label={`Child-${i + 1} Age`} span={1}>
                                                    <Select
                                                        value={form.child_age?.[i]?.age ?? 0}
                                                        onChange={(value) => {
                                                            setForm((prev) => {
                                                                const updatedAges = [...(prev.child_age || [])];

                                                                updatedAges[i] = {
                                                                    name: `child-${i + 1} age`,
                                                                    age: Number(value),
                                                                };

                                                                return {
                                                                    ...prev,
                                                                    child_age: updatedAges,
                                                                };
                                                            });
                                                        }}
                                                        options={[
                                                            { label: "0-1", value: 0 },
                                                            ...Array.from(
                                                                { length: Number(room?.child_age_limit || 0) },
                                                                (_, ageIndex) => ({
                                                                    label: `${ageIndex + 1}`,
                                                                    value: ageIndex + 1,
                                                                })
                                                            ),
                                                        ]}
                                                    />
                                                </FormField>
                                            ))}

                                            {/* <FormField label="Age Group" span={1}>
                                                <NumberInput
                                                    value={form.infant ?? 0}
                                                    min={0}
                                                    max={room?.child_age_limit}
                                                    onChange={(v) => set("infant", v)}
                                                />
                                            </FormField> */}

                                            {/* <FormField label="Age Group" span={1}>
                                                    <Select
                                                        value={form.infant ?? 0}
                                                        onChange={(value) => set("infant", value)}
                                                        options={[
                                                            { label: "0-1", value: 0 },
                                                            ...Array.from(
                                                                { length: room?.child_age_limit || 0 },
                                                                (_, i) => ({
                                                                    label: `${i + 1}`,
                                                                    value: i + 1,
                                                                })
                                                            ),
                                                        ]}
                                                        placeholder="Select Age Group"
                                                    />
                                                </FormField> */}

                                        </Space>

                                    </FormField>
                                    {/* <FormField label="Payment Mode" span={1}>
                                        <Select value={form.payment_mode} options={["Cash", "UPI", "Card", "Bank Transfer", "Advance"]} onChange={(v) => set("payment_mode", v)} />
                                    </FormField> */}

                                    <FormField label="Special Requests" span={3}>
                                        <Textarea placeholder="Any special requirements, preferences or notes…" value={form.special_requests} onChange={(v) => set("special_requests", v)} rows={3} />
                                    </FormField>

                                </div>
                            </SectionCard>

                            <SectionCard

                                title="Document Upload" icon={<FileTextOutlined />}>
                                <p style={{ fontSize: 12.5, color: "#666", margin: "0 0 14px", lineHeight: 1.6 }}>
                                    Upload a copy of the guest's ID proof (Aadhaar, Passport, etc.). Accepted formats: JPG, PNG, PDF.
                                </p>
                                <div
                                    style={styles.dropZone}
                                    onClick={() => fileRef.current.click()}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) => { e.preventDefault(); handleFiles({ target: { files: e.dataTransfer.files } }); }}
                                >
                                    <CloudUploadOutlined style={{ fontSize: 32, color: "#1677ff", marginBottom: 8 }} />
                                    <div style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>Click or drag files here</div>
                                    <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>JPG, PNG, PDF · Max 10MB each</div>
                                    <input ref={fileRef} type="file" multiple accept=".jpg,.jpeg,.png,.pdf" style={{ display: "none" }} onChange={handleFiles} />
                                </div>

                                {docs.length > 0 && (
                                    <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 8 }}>
                                        {docs.map((d, i) => (
                                            <div key={i} style={styles.docItem}>
                                                <FileTextOutlined style={{ fontSize: 18, color: "#1677ff", flexShrink: 0 }} />
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <div style={{ fontSize: 12.5, fontWeight: 600, color: "#222", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.name}</div>
                                                    <div style={{ fontSize: 11, color: "#aaa" }}>{d.size}</div>
                                                </div>
                                                <a href={d.url} target="_blank" rel="noreferrer" style={styles.docBtn} title="Preview"><EyeOutlined /></a>
                                                <button style={{ ...styles.docBtn, color: "#ff4d4f" }} onClick={() => removeDoc(i)} title="Remove"><DeleteOutlined /></button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </SectionCard>

                            <div style={styles.cta}>
                                <Button danger size="large" onClick={() => {
                                    if (selectedUpcoming) {
                                        // deselect upcoming
                                        setSelectedUpcoming(null);
                                        setIsNewReservation(false);
                                        if (existingUser?.length > 0) {
                                            const u = existingUser[0];
                                            setForm({ ...emptyForm, ...u, guests: Number(u.guests) || 1 });
                                        } else {
                                            setForm(emptyForm);
                                        }
                                    } else {
                                        onBack();
                                    }
                                }}>
                                    {selectedUpcoming ? "Deselect" : "Clear"}
                                </Button>


                                {/* Was: (selectedUpcoming || (!isNewReservation && existingUser)) */}
                                {(selectedUpcoming || (!isNewReservation && existingUser) || isOnlineBookingView) ? (
                                    <Tooltip title={!canUpdateModule(MODULE_KEY) ? "No permission to save changes" : ""}>
                                        <Button
                                            icon={<SaveOutlined />}
                                            type="primary"
                                            size="large"
                                            disabled={!canUpdateModule(MODULE_KEY)}
                                            onClick={() => handleUpdate()}
                                            loading={loading}
                                        >
                                            Save changes
                                        </Button>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title={!canCreateModule(MODULE_KEY) ? "No permission to book room" : ""}>
                                        <Dropdown
                                            size="large"
                                            menu={{ items, onClick: handleMenuClick }}
                                            disabled={!canCreateModule(MODULE_KEY)}
                                        >
                                            <Button
                                                icon={<DownOutlined />}
                                                size="large"
                                                loading={loading}
                                                disabled={!canCreateModule(MODULE_KEY)}
                                            >
                                                Actions
                                            </Button>
                                        </Dropdown>
                                    </Tooltip>
                                )}
                            </div>
                        </>)}
                    </div>
                </div>
            </Card>

            {/* ── Check-Out Modal (rendered outside Card to avoid z-index issues) ── */}

            <CheckOutModal
                open={checkOutModalOpen}
                onClose={() => setCheckOutModalOpen(false)}
                onConfirm={handleCheckOut}
                form={selectedUpcoming || form}
                room={room}
                loading={checkOutLoading}
                headerImg={`${ENDPOINTS.IMG_HEADER}${headerImg}`}
                headerA4Img={`${ENDPOINTS.IMG_HEADER}${a4PdfHeaderImg}`}
                footerImg={`${ENDPOINTS.IMG_HEADER}${footerImg}`}
                gst={gst}
                gstType={gstType}
            />
            <CancleCheckModal
                open={cancelCheckModalOpen}
                onClose={() => setCancelCheckModalOpen(false)}
                onConfirm={handleCheckOut}
                form={form}
                room={room}
                loading={checkOutLoading}
            />

            <ServiceRequestModal
                open={serviceReqModalOpen}
                onClose={() => setServiceReqModalOpen(false)}
                form={form}
                room={room}
                loading={checkOutLoading}
                allBookings={allBookings}
            />
        </>
    );
}

/* ══════════════════════════════════════════════════════ */
/*  SUCCESS SCREEN                                        */
/* ══════════════════════════════════════════════════════ */
//   paidAmount })
// Replace SuccessScreen full code with this
function SuccessScreen({
    bookId,
    room,
    form,
    nights,
    total,
    onBack,
    grandTotal,
    paidAmount,
    receivedAdvance,
    remainingPayable,
    discountAmount,
    amountType,
    paymentStatus,
    pricing_summary,
    loyaltyDiscountPercent,
    loyaltyDiscountAmount,
    gst,
    gstType = "exclusive",
    gstPercent = 0,
    gstAmount = 0,
    headerImg,
    headera4Img,
    footerImg,
    hourlyBook,
    totalHours,
    overdue_amount = 0,
    early_checkin_amount = 0,

    full_book,
    finalRemainingPayable,

}) {
    const fmt = (value) => `₹${Number(value || 0).toLocaleString()}`;

    const totalPayable = Number(grandTotal || total || pricing_summary?.total_amount || 0);
    const paid = Number(paidAmount || pricing_summary?.paid_amount || 0);
    const discount = Number(discountAmount || pricing_summary?.discount_amount || 0);
    const advance = Number(receivedAdvance || pricing_summary?.received_advance || 0);
    const remaining = Number(remainingPayable || pricing_summary?.remaining_payable || 0);

    const finalAmountType = amountType || pricing_summary?.amount_type || null;

    const isDiscount = finalAmountType === "discount" || discount > 0;
    const isAdvance = finalAmountType === "advance" || advance > 0 || remaining > 0;

    const isFullPaid = isDiscount
        ? paid + discount >= totalPayable
        : remaining <= 0 && paid >= totalPayable;

    const finalStatus =
        paymentStatus ||
        pricing_summary?.payment_status ||
        (isDiscount
            ? "Discount Applied"
            : isFullPaid
                ? "Fully Paid"
                : "Advance Received");

    const loyaltyPercent = Number(
        loyaltyDiscountPercent || pricing_summary?.loyalty_discount_percent || 0
    );

    const loyaltyAmount = Number(
        loyaltyDiscountAmount || pricing_summary?.loyalty_discount_amount || 0
    );

    const finalGstType = gstType || pricing_summary?.gst_type || "exclusive";
    const finalGstPercent = Number(gstPercent || pricing_summary?.gst_percent || gst || 0);
    const finalGstAmount = Number(gstAmount || pricing_summary?.gst_amount || 0);

    return (
        <div
            style={{
                ...styles.page,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "80vh",
            }}
        >
            <div style={styles.successCard}>
                <div style={styles.successIcon}>
                    <CheckCircleOutlined />
                </div>

                <div
                    style={{
                        fontSize: 22,
                        fontWeight: 700,
                        color: "#111",
                        marginBottom: 4,
                    }}
                >
                    Booking Confirmed!
                </div>

                <div style={{ fontSize: 13, color: "#888", marginBottom: 24 }}>
                    Booking ID: <b style={{ color: "#1677ff" }}>#{bookId}</b>
                </div>

                <div style={styles.successGrid}>
                    {[
                        ["Room", room?.room_name],
                        ["Room No.", `#${room?.room_number}`],
                        ["Guest", form?.guest_name],
                        ["Phone", form?.phone],
                        ["Check-In", form?.check_in],
                        ["Check-Out", form?.check_out],
                        ["Nights", nights],
                        ["Adult", form?.guests],
                        [
                            "Child Summary",
                            form?.child_age?.length
                                ? `${form.child_age.length} Child${form.child_age.length > 1 ? "ren" : ""} (${form.child_age
                                    .map((c) => (c.age === 0 ? "0-1Y" : `${c.age}Y`))
                                    .join(", ")})`
                                : "No Children"
                        ],
                    ["Payment Mode", (() => {
                            const rows = Array.isArray(pricing_summary?.payment_rows)
                                ? pricing_summary.payment_rows
                                : typeof pricing_summary?.payment_rows === "string"
                                    ? (() => { try { return JSON.parse(pricing_summary.payment_rows); } catch { return []; } })()
                                    : [];
                            if (rows.length > 0) {
                                const modes = [...new Set(rows.map(r => r.mode).filter(Boolean))];
                                return modes.join(" / ") || form?.payment_mode;
                            }
                            return form?.payment_mode;
                        })()],
                        ["Booking Type", hourlyBook ? "Hourly" : "Daily"],
                        [hourlyBook ? "Total Hours" : "Nights", hourlyBook ? totalHours : nights],

                        ...(full_book
                            ? [["24 Hours Additional Booking Price", `₹${Number(full_book || 0).toLocaleString()}`]]
                            : []),
                    ].map(([k, v]) => (
                        <div key={k} style={styles.successRow}>
                            <span style={{ color: "#888", fontSize: 12 }}>{k}</span>
                            <span style={{ fontWeight: 600, fontSize: 13 }}>
                                {v || "—"}
                            </span>
                        </div>
                    ))}
                </div>

                <div style={{ ...styles.successGrid, marginTop: 14 }}>
                    <div style={styles.successRow}>
                        <span style={{ color: "#888", fontSize: 12 }}>
                            Total Payable Amount
                        </span>
                        <span style={{ fontWeight: 700, fontSize: 13 }}>
                            {fmt(totalPayable)}
                        </span>
                    </div>

                    {loyaltyPercent > 0 && (
                        <div style={styles.successRow}>
                            <span style={{ color: "#888", fontSize: 12 }}>
                                Loyalty Member Discount ({loyaltyPercent}%)
                            </span>
                            <span style={{ fontWeight: 700, fontSize: 13, color: "#cf1322" }}>
                                -{fmt(loyaltyAmount)}
                            </span>
                        </div>
                    )}

                    {finalGstPercent > 0 && (
                        <div style={styles.successRow}>
                         <span style={{ color: "#888", fontSize: 12 }}>
GST ({finalGstPercent}%) - {finalGstType === "inclusive" ? "Inclusive (Added to Total)" : "Exclusive (Included in Total)"}
</span>
<span style={{ fontWeight: 700, fontSize: 13, color: finalGstType === "inclusive" ? "#237804" : "#cf1322"}}>
  {finalGstType === "inclusive" ? "+" : ""}{fmt(finalGstAmount)}
</span>
                        </div>
                    )}

                    <div style={styles.successRow}>
                        <span style={{ color: "#888", fontSize: 12 }}>
                            Paid Amount
                        </span>
                        <span style={{ fontWeight: 700, fontSize: 13 }}>
                            {fmt(paid)}
                        </span>
                    </div>

                    {isDiscount && (
                        <div style={styles.successRow}>
                            <span style={{ color: "#888", fontSize: 12 }}>
                                Discount Applied
                            </span>
                            <span style={{ fontWeight: 700, fontSize: 13 }}>
                                {fmt(discount)}
                            </span>
                        </div>
                    )}

                    {isAdvance && !isDiscount && (
                        <>
                            <div style={styles.successRow}>
                                <span style={{ color: "#888", fontSize: 12 }}>
                                    Advance Received
                                </span>
                                <span style={{ fontWeight: 700, fontSize: 13 }}>
                                    {fmt(advance || paid)}
                                </span>
                            </div>

                            <div style={styles.successRow}>
                                <span style={{ color: "#888", fontSize: 12 }}>
                                    Remaining Amount
                                </span>
                                <span style={{ fontWeight: 700, fontSize: 13 }}>
                                    {fmt(remaining)}
                                </span>
                            </div>
                        </>
                    )}

                    <div style={styles.successRow}>
                        <span style={{ color: "#888", fontSize: 12 }}>Full Paid</span>
                        <span style={{ fontWeight: 700, fontSize: 13 }}>
                            {isFullPaid ? "Yes" : "No"}
                        </span>
                    </div>

                    <div style={styles.successRow}>
                        <span style={{ color: "#888", fontSize: 12 }}>
                            Payment Status
                        </span>
                        <span style={{ fontWeight: 700, fontSize: 13 }}>
                            {finalStatus}
                        </span>
                    </div>

                    {Number(early_checkin_amount) > 0 && (
                        <div style={styles.successRow}>
                            <span style={{ color: "#888", fontSize: 12 }}>Early Check-in Charge</span>
                            <span style={{ fontWeight: 700, fontSize: 13, color: "#cf1322" }}>
                                +₹{Number(early_checkin_amount).toLocaleString()}
                            </span>
                        </div>
                    )}


                    {Number(overdue_amount) > 0 && (
                        <div style={styles.successRow}>
                            <span style={{ color: "#888", fontSize: 12 }}>Overdue Charges</span>
                            <span style={{ fontWeight: 700, fontSize: 13, color: "#cf1322" }}>
                                ₹{Number(overdue_amount).toLocaleString()}
                            </span>
                        </div>
                    )}
                </div>

                <div style={{ display: "flex", gap: 10, marginTop: 24 }}>
                    <button
                        style={{ ...styles.submitBtn, flex: 1 }}
                        onClick={() =>
                            generatePDF({
                                form,
                                bookId,
                                bookIds: [bookId],
                                rooms: [room],
                                nights,
                                total: totalPayable,
                                grandTotal: totalPayable,
                                paidAmount: paid,
                                receivedAdvance: advance,
                                remainingPayable: remaining,
                                discountAmount: discount,
                                amountType: isDiscount
                                    ? "discount"
                                    : isAdvance
                                        ? "advance"
                                        : finalAmountType,
                                paymentStatus: finalStatus,
                                pricing_summary,
                                loyaltyDiscountPercent: loyaltyPercent,
                                loyaltyDiscountAmount: loyaltyAmount,

                                gst: gst,
                                gstPercent,
                                gstAmount,
                                headerImg,
                                footerImg,
                                hourlyBook,
                                totalHours,

                                bookingType: hourlyBook ? "hourly" : "Day",
                                ratePerHour: room.total_price_per_hour,
                                overdue_amount: pricing_summary?.overdue_amount || 0,
                                early_checkin_amount: early_checkin_amount || pricing_summary?.early_checkin_amount || 0,
                                overdue_duration: pricing_summary?.overdue_duration || "",
                                full_book: full_book,

                                gstType: finalGstType,
                            })
                        }
                    >
                        🖨️ Print Bill
                    </button>

                    <button
                        style={{ ...styles.submitBtn, flex: 1 }}
                        onClick={() =>
                            generateA4PDF({
                                form,
                                bookIds: [bookId],
                                rooms: [room],
                                nights,
                                grandTotal: totalPayable,
                                paidAmount: paid,
                                receivedAdvance: advance,
                                remainingPayable: remaining,
                                discountAmount: discount,
                                amountType: isDiscount ? "discount" : isAdvance ? "advance" : finalAmountType,
                                paymentStatus: finalStatus,
                                pricing_summary,
                                loyaltyDiscountPercent: loyaltyPercent,
                                loyaltyDiscountAmount: loyaltyAmount,
                                gst,
                                gstType,
                                gstPercent,
                                gstAmount,
                                headera4Img,
                                footerImg,
                                hourlyBook,
                                totalHours,
                                bookingType: hourlyBook ? "hourly" : "Day",
                                ratePerHour: room.total_price_per_hour,
                                overdue_amount: pricing_summary?.overdue_amount || 0,
                                early_checkin_amount: early_checkin_amount || pricing_summary?.early_checkin_amount || 0,
                                overdue_duration: pricing_summary?.overdue_duration || "",
                                finalRemainingPayable: finalRemainingPayable,
                            })
                        }
                    >
                        🖨️ Print A4
                    </button>

                    <button
                        style={{ ...styles.submitBtn, flex: 1 }}
                        onClick={onBack}
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
}

const Badge = ({ cfg }) => (
    <span style={{ fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 20, background: cfg.badgeBg, color: cfg.badgeColor }}>
        {cfg.label}
    </span>
);

const Divider = () => <div style={{ height: 1, background: "rgba(0,0,0,0.07)", margin: "14px 0" }} />;

const FormField = ({ label, required, error, span = 1, children }) => (
    <div style={{ gridColumn: `span ${span}` }}>
        <label style={styles.label}>{label} {required && <span style={{ color: "#ff4d4f" }}>*</span>}</label>
        {children}
        {error && <div style={{ fontSize: 11, color: "#ff4d4f", marginTop: 3 }}>{error}</div>}
    </div>
);

const Input = ({
    prefix,
    placeholder,
    value,
    onChange,
    type = "text",
    min,
    max,
}) => (
    <>
        <style>
            {`
        .custom-input::placeholder {
          color: #aaaaaa80;
          opacity: 1;
        }
      `}
        </style>

        <div style={styles.inputWrap}>
            {prefix && <span style={styles.inputPrefix}>{prefix}</span>}
            <input
                className="custom-input"
                type={type}
                placeholder={placeholder}
                value={value}
                min={min}
                max={max}
                onChange={(e) => onChange(e.target.value)}
                style={{
                    ...styles.input,
                    paddingLeft: prefix ? 32 : 12,
                }}
            />
        </div>
    </>
);

const Textarea = ({ placeholder, value, onChange, rows = 3 }) => (
    <textarea className="custom-input" placeholder={placeholder} value={value} rows={rows} onChange={(e) => onChange(e.target.value)} style={styles.textarea} />
);

// const Select = ({ value, options, onChange }) => (
//     <select value={value} onChange={(e) => onChange(e.target.value)} style={styles.select}>
//         {options.map((o) => <option key={o} value={o}>{o}</option>)}
//     </select>
// );

const Select = ({ value, options = [], onChange }) => (
    <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={styles.select}
    >
        {options.map((o) => {
            const label = typeof o === "object" ? o.label : o;
            const optionValue = typeof o === "object" ? o.value : o;

            return (
                <option key={optionValue} value={optionValue}>
                    {label}
                </option>
            );
        })}
    </select>
);

const NumberInput = ({ value, min, max, onChange }) => (
    <div style={styles.numberInput}>
        <button style={styles.numBtn} onClick={() => onChange(Math.max(min ?? 1, value - 1))}>−</button>
        <span style={{ minWidth: 28, textAlign: "center", fontWeight: 600, fontSize: 14 }}>{value}</span>
        <button style={styles.numBtn} onClick={() => onChange(max != null ? Math.min(max, value + 1) : value + 1)}>+</button>
    </div>
);  
